import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { I18nService } from '@localize/services/';

import { isJSON } from '../../../shared/utilities';

/**
 * This service provides a way to do lookups for translation strings
 * from API error responses
 * saves the server from having to translate anything
 *
 */
@Injectable({
	providedIn: 'root'
})
export class ApiResponseStringsService {
	private idPrefix = 'api.error-code.';

	constructor(private i18nService: I18nService) {}

	/**
	 * Gets translated error message from error. Supports two formats, Portal and Whats response errors. Will try to get translated message
	 * based on error code and if not found then fallback to provided error message.
	 *
	 * @param response HttpErrorResponse with either Portal or Whats style error
	 */
	public stringForError(response: HttpErrorResponse): string {
		const errorMessage = isJSON(response.error?.errorMessage) ? JSON.parse(response.error?.errorMessage) : null;
		const error = isJSON(response.error) ? JSON.parse(response.error) : typeof response.error === 'object' ? response.error : null;

		let translation: string;

		if (response?.status === 0) {
			translation = this.i18nService.get(response?.message, this.idPrefix + 0);
		} else if (errorMessage) {
			translation = this.i18nService.get(errorMessage.defaultMessage, this.idPrefix + errorMessage.errorCode);

			if (errorMessage.fields) {
				errorMessage.fields.forEach((f: any) => {
					translation = translation.replace('%s', String(f));
				});
			}
		} else if (error) {
			translation = error?.message;

			// Only supports showing single error message so get first value
			if (Array.isArray(error?.errors) && error?.errors?.length > 0) {
				translation = this.i18nService.get(error?.message, this.idPrefix + error.errors[0].code);

				if (error.errors[0]?.field) {
					translation = translation.replace('%s', error.errors[0].field);
				}
			}
		}

		return translation || response.message || 'unknown error';
	}
}
